import React, { useEffect, useState } from 'react';
import { Field } from 'formik';

import {
  InputUI,
  DatePickerUI,
  AutoCompleteSelectUI,
  TimePickerUi,
  FormErrorUI,
  FormLabelUI,
  SelectUI,
} from '../Interface';
import companyService from '../../service/company.service';
import { generateAutocompleteItems } from '../../utils/helper';
import { CRMEventTypeList } from '../../config/CRMEventType';
import useParam from '../../context/ParamContext';

const CrmTaskFields = ({
  viewField,
  selectedValues,
  values,
  validateField,
  setFieldValue,
  errors,
  autoCompleteOptions,
  autocompleteData,
}) => {
  const { params } = useParam();
  const [companyContacts, setCompanyContacts] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const getCompanyData = async (companyId) => {
    const selCom = await companyService.getCompanyById(companyId);
    setSelectedCompany(selCom);
  };

  useEffect(() => {
    if (values.companyId) {
      setCompanyContacts([]);
      getCompanyData(values.companyId);
    } else {
      setSelectedCompany(null);
      setCompanyContacts([]);
    }
  }, [values.companyId]);

  useEffect(() => {
    if (!selectedCompany) {
      setFieldValue('companyContactId', null);
      return;
    }

    setCompanyContacts(generateAutocompleteItems(selectedCompany.companyContact, 'name', 'id'));

    if (!selectedValues.prefixedId) {
      const defContact = selectedCompany.companyContact.find((cc) => cc.default);
      setFieldValue('companyContactId', defContact?.id ?? selectedCompany?.companyContact[0]?.id ?? null);
    }
  }, [selectedCompany]);

  const defBillingAddress =
    selectedCompany &&
    selectedCompany?.companyAdress?.find((addr) => addr.adressType === 'BILLING' && addr.default === true);

  return (
    <>
      <div className="grid grid-cols-4 gap-x-4 gap-y-2 mx-4">
        <div className="col-span-3">
          <Field
            type="text"
            name="name"
            as={InputUI}
            fullWidth
            label={<FormLabelUI text="Esemény rövid neve" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.name} />}
            disabled={viewField}
            InputLabelProps={{ shrink: values.name !== '' }}
          />
        </div>
        <div className="col-span-1">
          <Field
            type="text"
            name="prefixedId"
            as={InputUI}
            fullWidth
            label={<FormLabelUI text="Azonosító" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.prefixedId} />}
            disabled
            InputLabelProps={{ shrink: values.prefixedId !== '' }}
          />
        </div>
        <div className="col-span-4 md:col-span-1 ">
          <Field
            type="date"
            name="startDate"
            component={DatePickerUI}
            value={values.startDate}
            fullWidth
            label={<FormLabelUI text="Kezdő dátum" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.startDate} />}
            onChange={(date) => {
              setFieldValue('startDate', date).then(() => {
                validateField('startDate');
              });
            }}
            disabled={viewField}
            InputLabelProps={{ shrink: values.startDate !== '' }}
          />
        </div>
        <div className="col-span-4 md:col-span-1">
          <Field
            type="time"
            name="startDate"
            component={TimePickerUi}
            value={values.startDate}
            fullWidth
            label={<FormLabelUI text="Kezdő időpont" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.startDate} />}
            onChange={(date) => {
              setFieldValue('startDate', date).then(() => {
                validateField('startDate');
              });
            }}
            disabled={viewField}
            InputLabelProps={{ shrink: values.startDate !== '' }}
          />
        </div>
        <div className="col-span-4 md:col-span-1">
          <Field
            type="date"
            name="endDate"
            component={DatePickerUI}
            value={values.endDate}
            fullWidth
            label={<FormLabelUI text="Befejező dátum" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.endDate} />}
            onChange={(date) => {
              setFieldValue('endDate', date).then(() => {
                validateField('endDate');
              });
            }}
            disabled={viewField}
            InputLabelProps={{ shrink: values.endDate !== '' }}
          />
        </div>
        <div className="col-span-4 md:col-span-1">
          <Field
            type="text"
            name="duration"
            as={InputUI}
            fullWidth
            label={<FormLabelUI text="Időintervallum" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.duration} />}
            disabled={viewField}
            InputLabelProps={{ shrink: values.duration !== '' }}
            onChange={(e) => {
              const newendDate = values.startDate.add(e.target.value, 'hour');
              setFieldValue('duration', e.target.value ?? '');
              setFieldValue('endDate', newendDate).then(() => {
                validateField('endDate');
              });
            }}
          />
        </div>
        <div className="col-span-4 md:col-span-2">
          <Field
            type="autocomplete"
            name="projectId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Projekt" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.projectId} />}
            onChange={(_e, newVal) => {
              setFieldValue('projectId', newVal?.value ?? null).then(() => {
                validateField('projectId');
              });

              const findedProject = autocompleteData.project.find((i) => i.projectId === newVal?.value);
              setFieldValue('companyId', findedProject?.companyId ?? null);
            }}
            disabled={viewField}
            InputLabelProps={{ shrink: values.projectId !== '' }}
            selectedValue={values.projectId}
            selectedLabelValue={selectedValues?.project?.projectName}
            dataset={autoCompleteOptions.project}
          />
        </div>
        <div className="col-span-4 md:col-span-2">
          <Field
            type="autocomplete"
            name="companyId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Cég" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.companyId} />}
            onChange={(_e, newVal) => {
              setFieldValue('companyId', newVal?.value ?? null).then(() => {
                validateField('companyId');
              });
            }}
            disabled={viewField}
            InputLabelProps={{ shrink: values.companyId !== '' }}
            selectedValue={values.companyId}
            selectedLabelValue={selectedValues?.company?.name}
            dataset={autoCompleteOptions.company}
          />
        </div>
        <div className="col-span-4 md:col-span-2">
          <Field
            type="autocomplete"
            name="typeId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Esemény típusa" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.typeId} />}
            onChange={(_e, newVal) => {
              setFieldValue('typeId', newVal?.value ?? null).then(() => {
                validateField('typeId');
              });
            }}
            disabled={viewField}
            InputLabelProps={{ shrink: values.typeId !== '' }}
            selectedValue={values.typeId}
            selectedLabelValue={selectedValues?.type?.itemName}
            dataset={autoCompleteOptions.type}
          />
        </div>
        <div className="col-span-4 md:col-span-2">
          <Field
            type="autocomplete"
            name="statusId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Státusz" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.statusId} />}
            onChange={(_e, newVal) => {
              setFieldValue('statusId', newVal?.value ?? null).then(() => {
                validateField('statusId');
              });
            }}
            disabled={viewField}
            InputLabelProps={{ shrink: values.statusId !== '' }}
            selectedValue={values.statusId}
            selectedLabelValue={selectedValues?.status?.itemName}
            dataset={autoCompleteOptions.status}
          />
        </div>
        <div className="col-span-4 md:col-span-1">
          <Field
            type="autocomplete"
            name="responsiblePersonId"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Felelős" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.responsiblePersonId} />}
            onChange={(_e, newVal) => {
              setFieldValue('responsiblePersonId', newVal?.value ?? null).then(() => {
                validateField('responsiblePersonId');
              });
            }}
            disabled={viewField}
            InputLabelProps={{ shrink: values.responsiblePersonId !== '' }}
            selectedValue={values.responsiblePersonId}
            selectedLabelValue={selectedValues?.responsiblePerson?.userName}
            dataset={autoCompleteOptions.user}
          />
        </div>
        <div className="col-span-4 md:col-span-1">
          <Field
            type="text"
            name="parentName"
            as={InputUI}
            fullWidth
            label={<FormLabelUI text="Szülő" />}
            variant="standard"
            disabled
            InputLabelProps={{ shrink: values.parentName !== '' }}
          />
        </div>
        <div className="col-span-4 md:col-span-1">
          <Field
            type="autocomplete"
            name="createdBy"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Tulajdonos" />}
            variant="standard"
            disabled
            InputLabelProps={{ shrink: values.createdBy !== '' }}
            selectedValue={values.createdBy}
            selectedLabelValue={selectedValues?.user?.userName}
            dataset={autoCompleteOptions.user}
          />
        </div>
        <div className="col-span-4 md:col-span-1">
          <Field
            name="eventType"
            component={SelectUI}
            fullWidth
            label={<FormLabelUI text="Esemény fajtája" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.eventType} />}
            onChange={(e) => {
              const value = e.target.value;
              setFieldValue('eventType', value ?? null).then(() => {
                validateField('eventType');
              });
            }}
            value={values.eventType ?? ''}
            disabled={viewField}
            option={CRMEventTypeList}
          />
        </div>

        <div className="col-span-4 md:col-span-1">
          <Field
            type="autocomplete"
            name="companyContactId"
            component={AutoCompleteSelectUI}
            fullWidth
            disabled={viewField || companyContacts.length === 0}
            label={<FormLabelUI text="Kapcsolattartó" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.companyContactId} />}
            InputLabelProps={{ shrink: Boolean(values.companyContactId) }}
            selectedValue={companyContacts.length > 0 ? values.companyContactId : null}
            onChange={(_e, newVal) => {
              setFieldValue('companyContactId', newVal?.value ?? null).then(() => {
                validateField('companyContactId');
              });
            }}
            selectedLabelValue={
              companyContacts.length > 0
                ? companyContacts.find((cc) => cc.value === values.companyContactId)?.label
                : ''
            }
            dataset={companyContacts}
          />
        </div>
        <div className="col-span-1">
          <InputUI
            fullWidth
            label={<FormLabelUI text="Kapcsolattartó telefonszáma" />}
            variant="standard"
            value={selectedCompany?.companyContact?.find((cc) => cc.id === values.companyContactId)?.phoneNumber ?? ''}
            disabled
          />
        </div>
        <div className="col-span-1">
          <InputUI
            fullWidth
            label={<FormLabelUI text="Kapcsolattartó email címe" />}
            variant="standard"
            value={selectedCompany?.companyContact?.find((cc) => cc.id === values.companyContactId)?.email ?? ''}
            disabled
          />
        </div>
      </div>
      <div className="grid grid-cols-4 gap-x-4 gap-y-3 mx-4 mb-5">
        {params.COMPANY_SHOW_CONTACT_ADDRESS_IN_FIELD === 'Y' && defBillingAddress && (
          <>
            <div className="col-span-1">
              <InputUI
                fullWidth
                label={<FormLabelUI text="Alap. cím – Irányítószám" />}
                variant="standard"
                value={defBillingAddress.postCode ?? ''}
                disabled
              />
            </div>
            <div className="col-span-1">
              <InputUI
                fullWidth
                label={<FormLabelUI text="Alap. cím – Város" />}
                variant="standard"
                value={defBillingAddress.city ?? ''}
                disabled
              />
            </div>
            <div className="col-span-1">
              <InputUI
                fullWidth
                label={<FormLabelUI text="Alap. cím – Utca, házszám" />}
                variant="standard"
                value={defBillingAddress.streetAddress ?? ''}
                disabled
              />
            </div>
            <div className="col-span-1">
              <InputUI
                fullWidth
                label={<FormLabelUI text="Alap. cím – Megye" />}
                variant="standard"
                value={defBillingAddress.province ?? ''}
                disabled
              />
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CrmTaskFields;
